import React from "react";
import Agent from "./Agent";
import { Helmet } from "react-helmet";

import data from "../../../data/data";

import "./agentsPage.scss";

const Agents = () => {
  const [AgentList, setAgentList] = React.useState(data);

  return (
    <div className='contentAgents'>
      <Helmet>
        <title>Valorant Tracker | Agents</title>
        <meta name='description' content='Helmet application' />
      </Helmet>
      <div className='mainAgent pt-24'>
        <div className='text-4xl mt-10 text-white font-extrabold tracking-widest '>
          {" "}
          VALORANT Agents
        </div>
        <hr className='mt-10'></hr>
        <div className=' grid mt-5 justify-center '>
          {AgentList.map((agent) => (
            <Agent key={agent.name} agent={agent}></Agent>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Agents;
